module.exports = __webpack_public_path__ + "img/ja-logo.ac4f2d62.svg";